/**
 * @file Mixpanel helper.
 */

import getConfig from './config';

/**
 * Initializes Mixpanel and returns tracking helpers.
 *
 * @param {Object} mixpanel - The Mixpanel client.
 * @param {string} project - The project name.
 * @param {string} [token] - The Mixpanel token.
 * @returns {{identify: function, alias: function, track: function, people: {set: function}}}
 */
const Mixpanel = (mixpanel, project, token) => {
  if (!project) {
    throw new Error('Mixpanel init: `project` param is required.');
  }

  if (token) {
    mixpanel.init(token, {}, project);
  }

  return {
    identify: id => {
      if (token) {
        mixpanel[project].identify(id);
      }
    },
    alias: id => {
      if (token) {
        mixpanel[project].alias(id);
      }
    },
    track: (name, props) => {
      const config = getConfig();

      if (token) {
        mixpanel[project].track(name, {
          ...props,
          app_version: config.app.version,
        });
      }
    },
    people: {
      set: props => {
        if (token) {
          mixpanel[project].people.set(props);
        }
      },
    },
  };
};

export default Mixpanel;
